import { FC, ReactNode } from 'react';
import { FrownIcon } from 'lucide-react';

interface EmptyStateProps {
  message: string;
  description?: string;
  icon?: ReactNode;
  className?: string;
}

export const EmptyState: FC<EmptyStateProps> = ({ message, description, icon, className = '' }) => {
  return (
    <div
      className={`flex flex-col gap-3 text-center py-8 ${className} rounded-xl bg-(--neutral-white-NW1000)`}
    >
      <div className="flex justify-center">
        {icon ?? <FrownIcon className="w-7 h-7 text-muted-foreground opacity-40" />}
      </div>
      <div>
        <p className="text-(--neutral-black-NB600) [font-size:var(--fs-p4)] font-medium m-0!">
          {message}
        </p>
        {description && (
          <p className="[font-size:var(--fs-l5)] text-muted-foreground m-0!">{description}</p>
        )}
      </div>
    </div>
  );
};
